import { FirstStep } from './FirstStep';
import { SecondStep } from './SecondStep';
import { ThirdStep } from './ThirdStep';

export const stepsList = [
  {
    title: 'Availability Check',
    mobileTitle: 'Avail Check',
    component: FirstStep,
  },
  {
    title: 'Status Check',

    component: SecondStep,
  },
  {
    title: 'Booking',
    component: ThirdStep,
  },
];
